import { FUEL_TYPE_MAP, STATE_MAPPER } from "../docs/constants";

export const generateDocsReport = (docsFormData, docsOutput) => {
  const excludedKeys = ['Inputs', 'TransactionID', 'Type', 'Notes'];

  const documents = Object.entries(docsOutput || {}).filter(
    ([key, value]) => !excludedKeys.includes(key) && Array.isArray(value)
  );

  const nonLinkItems = documents.filter(([, [pdfUrl]]) => !pdfUrl);
  const linkItems = documents.filter(([, [pdfUrl]]) => pdfUrl);
  const notes = docsOutput?.Notes;

  const notesHtml = notes?.split('|').map((note, index) => (
    `<li key=${index} dangerouslySetInnerHTML={{ __html: ${(note?.replaceAll('<a ', '<a target="_blank" '))}}} />`
  ))

  const nonLinkItemsHtml = nonLinkItems.map(([key, [, html]]) => (`
    <div key=${key} class="bg-white p-6 rounded-xl border text-sm docs-output-form">
      <h4 class="font-medium text-gray-800 mb-2">${key}</h4>
      <ul class="list-disc pl-6 text-xs text-gray-700 sanitizedHtml">
        ${html ? html.replaceAll('<a ', '<a target="_blank" ') : ''}
      </ul>
    </div>`
  ));

  const linkItemsHtml =
    linkItems.map(([key, [pdfUrl, html]]) => (`
      <div key=${key} class="flex justify-between items-start border-b pb-4 last:border-0">
        <div>
          <h4 class="font-medium text-gray-800">${key}</h4>
          ${html ? `
            <ul class="list-disc pl-4 mt-1 text-xs text-gray-600 sanitizedHtml">
              ${html.replaceAll('<a ', '<a target="_blank" ')}
            </ul>
          ` : ``}
        </div>
        <a
          href="${encodeURI(pdfUrl)}"
          download
          target="_blank"
          rel="noopener noreferrer"
          class="border border-gray-300 w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer ml-4 shrink-0"
        >
          <img src="/download-icon.png" alt="" >
        </a>
      </div>`
    ))



  const getStateFullName = (abbr) => {
    return STATE_MAPPER[abbr] || abbr;
  };

  const convertArray = (arr) => {
    let str = "";
    for (let i = 0; i < arr?.length; i++) {
      str += arr[i];
    }

    return str;
  }

  return (
    `<div class="default-bg-color p-6">
      <div class='flex flex-col gap-4 w-full'>
        <div class='flex flex-row text-gray-700 font-bold mb-2 items-center h-11'>
          Your Information
        </div>

        <div class='bg-white p-6 rounded-xl text-sm border border-gray-300'>
          <div class='text-gray-700 mb-3 font-medium'>
            Location Information
          </div>

          <div class='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
            <div class='flex flex-col w-full text-gray-700 gap-2'>
              ${docsFormData?.zipCode ? `
                <div class='flex flex-row justify-between'>
                  <div>Zip Code:</div>
                  <div class='font-medium'>${docsFormData.zipCode}</div>
                </div>
              ` : ""}

              ${docsFormData?.city ? `
                <div class='flex flex-row justify-between'>
                  <div>City:</div>
                  <div class='font-medium'>${docsFormData.city}</div>
                </div>
              ` : ""}

              <div class='flex flex-row justify-between'>
                <div>Outside city limits:</div>
                <div class='font-medium'>${docsFormData?.outSideCityLimit ? "Yes" : "No"}</div>
              </div>
            </div>

            <div class='flex flex-col w-full text-gray-700 gap-2'>
              ${docsFormData?.state ? `
                <div class='flex flex-row justify-between'>
                  <div>
                    State:
                  </div>
                  <div class='font-medium'>
                    ${getStateFullName(docsFormData?.state)}
                  </div>
                </div>
              ` : ""
              }

              ${docsFormData?.country ? `
                <div class='flex flex-row justify-between'>
                  <div>
                    County:
                  </div>
                  <div class='font-medium'>
                    ${docsFormData?.country}
                  </div>
                </div>
              ` : ""
              }
            </div>
          </div>

          <div>
            <div class='border-t-2 border-t-gray-100 mb-3'>
              <div class='text-gray-700 mt-6 font-bold'>
                Vehicle Information <span class='text-xs text-gray-600 font-normal ml-1'>${docsFormData?.vinCode ? docsFormData?.vinCode : ''}</span>
              </div>
            </div>

            <div class='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
              <div class='flex flex-col w-full text-gray-700 gap-2'>
                ${docsFormData?.vehicleType ? `
                  <div class='flex flex-row justify-between'>
                    <div>Vehicle Type:</div>
                    <div class='font-medium'>${docsFormData.vehicleType}</div>
                  </div>
                ` : ""}

                ${docsFormData?.modelYear ? `
                  <div class='flex flex-row justify-between'>
                    <div>Model Year:</div>
                    <div class='font-medium'>${docsFormData.modelYear}</div>
                  </div>
                ` : ""}

                ${docsFormData?.model ? `
                  <div class='flex flex-row justify-between'>
                    <div>Model:</div>
                    <div class='font-medium'>${docsFormData.model}</div>
                  </div>
                ` : ""}

                ${docsFormData?.numberOfAxles ? `
                  <div class='flex flex-row justify-between'>
                    <div>Number of Axles:</div>
                    <div class='font-medium'>${docsFormData.numberOfAxles}</div>
                  </div>
                ` : ""}

                ${docsFormData?.fuelType ? `
                  <div class='flex flex-row justify-between'>
                    <div>Fuel Type:</div>
                    <div class='font-medium'>${FUEL_TYPE_MAP[docsFormData.fuelType]}</div>
                  </div>
                ` : ""}

                ${docsFormData?.registrationMonths ? `
                  <div class='flex flex-row justify-between'>
                    <div>Registration Months:</div>
                    <div class='font-medium'>${docsFormData.registrationMonths}</div>
                  </div>
                ` : ""}

                ${docsFormData?.odometer ? `
                  <div class='flex flex-row justify-between'>
                    <div>Odometer (miles): </div>
                    <div class='font-medium'>${Number(docsFormData?.odometer).toLocaleString()}</div>
                  </div>
                ` : ""}

                ${docsFormData?.color ? `
                  <div class='flex flex-row justify-between'>
                    <div>Color:</div>
                    <div class='font-medium'>${docsFormData.color}</div>
                  </div>
                ` : ""}

                ${docsFormData?.gvw ? `
                  <div class='flex flex-row justify-between'>
                    <div>GVW:</div>
                    <div class='font-medium'>${Number(docsFormData?.gvw).toLocaleString()} lbs</div>
                  </div>
                ` : ""}

                ${docsFormData?.horsepower ? `
                  <div class='flex flex-row justify-between'>
                    <div>Horsepower:</div>
                    <div class='font-medium'>${Number(docsFormData?.horsepower).toLocaleString()}</div>
                  </div>
                ` : ""}

                
              </div>

              <div class='flex flex-col w-full text-gray-700 gap-2'>
                ${docsFormData?.condition ? `
                  <div class='flex flex-row justify-between'>
                    <div>Condition:</div>
                    <div class='font-medium'>${docsFormData.condition}</div>
                  </div>
                ` : ""}

                ${docsFormData?.make ? `
                  <div class='flex flex-row justify-between'>
                    <div>Make:</div>
                    <div class='font-medium'>${docsFormData.make}</div>
                  </div>
                ` : ""}

                ${docsFormData?.bodyStyle ? `
                  <div class='flex flex-row justify-between'>
                    <div>Body Style:</div>
                    <div class='font-medium'>${docsFormData.bodyStyle}</div>
                  </div>
                ` : ""}

                ${docsFormData?.numberOfTires ? `
                  <div class='flex flex-row justify-between'>
                    <div>Number of Tires:</div>
                    <div class='font-medium'>${docsFormData.numberOfTires}</div>
                  </div>
                ` : ""}

                ${docsFormData?.cylinders ? `
                  <div class='flex flex-row justify-between'>
                    <div>Cylinders:</div>
                    <div class='font-medium'>${docsFormData.cylinders}</div>
                  </div>
                ` : ""}

                ${docsFormData?.rimSize ? `
                  <div class='flex flex-row justify-between'>
                    <div>Rim Size (Inches):</div>
                    <div class='font-medium'>${docsFormData.rimSize}</div>
                  </div>
                ` : ""}

                ${docsFormData?.vehicleWeight ? `
                  <div class='flex flex-row justify-between'>
                    <div>Weight:</div>
                    <div class='font-medium'>${Number(docsFormData?.vehicleWeight).toLocaleString()} lbs</div>
                  </div>
                ` : ""}

                ${docsFormData?.mpg ? `
                  <div class='flex flex-row justify-between'>
                    <div>MPG (Average):</div>
                    <div class='font-medium'>${docsFormData.mpg}</div>
                  </div>
                ` : ""}

                ${docsFormData?.msrp ? `
                  <div class='flex flex-row justify-between'>
                    <div>MSRP:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.msrp)}
                    </div>
                  </div>
                ` : ""}
              </div>
            </div>
          </div>

          <div>
            <div class='border-t-2 border-t-gray-100 mb-3'>
              <div class='text-gray-700 mt-6 font-bold'>
                Transaction Information
              </div>
            </div>

            <div class='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
              <div class='flex flex-col w-full text-gray-700 gap-2'>
                ${docsFormData?.transactionType ? `
                  <div class='flex flex-row justify-between'>
                    <div>
                      Transaction Type:
                    </div>
                    <div class='font-medium'>
                      ${docsFormData.transactionType}
                    </div>
                  </div>
                ` : ``}

                ${docsFormData?.uploadDate ? `
                  <div class='flex flex-row justify-between'>
                    <div>Uploaded Date:</div>
                    <div class='font-medium'>${docsFormData.uploadDate}</div>
                  </div>
                ` : ""}

                ${docsFormData?.plateNumber ? `
                  <div class='flex flex-row justify-between'>
                    <div>Plate Number:</div>
                    <div class='font-medium'>${docsFormData.plateNumber}</div>
                  </div>
                ` : ""}

                ${docsFormData?.docsFees ? `
                  <div class='flex flex-row justify-between'>
                    <div>Docs Price:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.docsFees)}
                    </div>
                  </div>
                ` : ""}

                ${docsFormData?.extendedWarranties ? `
                  <div class='flex flex-row justify-between'>
                    <div>Extended Warranties:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.extendedWarranties)}
                    </div>
                  </div>
                ` : ""}

                ${docsFormData?.protectionPackages ? `
                  <div class='flex flex-row justify-between'>
                    <div>Protection Packages:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.protectionPackages)}
                    </div>
                  </div>
                ` : ""}

                <div class='flex flex-row justify-between'>
                  <div>Military:</div>
                  <div class='font-medium'>${docsFormData.military ? "Yes" : "No"}</div>
                </div>

                <div class='flex flex-row justify-between'>
                  <div>Lien:</div>
                  <div class='font-medium'>${docsFormData.lien ? "Yes" : "No"}</div>
                </div>
              </div>

              <div class='flex flex-col w-full text-gray-700 gap-2'>
                ${docsFormData?.transactionDate ? `
                  <div class='flex flex-row justify-between'>
                    <div>Transaction Date:</div>
                    <div class='font-medium'>${docsFormData.transactionDate}</div>
                  </div>
                ` : ""}

                ${docsFormData?.plateType ? `
                  <div class='flex flex-row justify-between'>
                    <div>Plate type:</div>
                    <div class='font-medium'>${docsFormData.plateType}</div>
                  </div>
                ` : ""}

                ${docsFormData?.basePrice ? `
                  <div class='flex flex-row justify-between'>
                    <div>Base price:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.basePrice)}
                    </div>
                  </div>
                ` : ""}

                ${docsFormData?.additionalFees ? `
                  <div class='flex flex-row justify-between'>
                    <div>Additional Fee:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.additionalFees)}
                    </div>
                  </div>
                ` : ""}

                ${docsFormData?.insurancePackages ? `
                  <div class='flex flex-row justify-between'>
                    <div>Insurance package:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.insurancePackages)}
                    </div>
                  </div>
                ` : ""}

                ${docsFormData?.protectionPackages ? `
                  <div class='flex flex-row justify-between'>
                    <div>Theft Protection:</div>
                    <div class='font-medium'>
                      ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(docsFormData.protectionPackages)}
                    </div>
                  </div>
                ` : ""}

                  <div class='flex flex-row justify-between'>
                    <div>
                      Plate Transfer:
                    </div>
                    <div class='font-medium'>
                      ${docsFormData?.plateTransfer ? "Yes" : "No"}
                    </div>
                  </div>

                 ${docsFormData?.driverCategory ? `
                  <div class='flex flex-row justify-between'>
                    <div>Theft Protection:</div>
                    <div class='font-medium'>${docsFormData.driverCategory}</div>
                  </div>
                ` : ""}
              </div>
            </div>
          </div>

          ${( docsFormData?.insuranceCompany || docsFormData?.insuranceExpirationDate || docsFormData?.insuranceDate || docsFormData?.insurancePolicyNumber) ? `
            <div>
              <div class='border-t-2 border-t-gray-100 mb-3'>
                <div class='text-gray-700 mt-6 font-medium'>
                  Insurance Information
                </div>
              </div>

              <div class='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
                <div class='flex flex-col w-full text-gray-700 gap-2'>
                  <div class='flex flex-row justify-between'>
                    <div>Insurance Company:</div>
                    <div class='font-medium'>${docsFormData.insuranceCompany}</div>
                  </div>

                  <div class='flex flex-row justify-between'>
                    <div>Insurance Expiration Date:</div>
                    <div class='font-medium'>${docsFormData.insuranceExpirationDate}</div>
                  </div>
                </div>

                <div class='flex flex-col w-full text-gray-700 gap-2'>
                  <div class='flex flex-row justify-between'>
                    <div>Insurance Date:</div>
                    <div class='font-medium'>${docsFormData.insuranceDate}</div>
                  </div>

                  <div class='flex flex-row justify-between'>
                    <div>Insurance Number:</div>
                    <div class='font-medium'>${docsFormData.insurancePolicyNumber}</div>
                  </div>
                </div>
              </div>
            </div>
          ` : "" }
        </div>
      </div>

      <div class="mt-4 flex flex-col w-full space-y-6">
        <div class="flex justify-between items-center">
          <div class="flex flex-row text-gray-700 font-bold items-center h-11">Documents Output</div>
        </div>

        ${notes ? `
          <div class="bg-white p-6 rounded-xl border text-sm docs-output-form">
            <h4 class="text-gray-800 font-semibold mb-4">Notes</h4>
            <ul class="list-disc pl-6 space-y-2 text-gray-700 text-xs">
              ${convertArray(notesHtml)}
            </ul>
          </div>
        ` : ''}

        ${convertArray(nonLinkItemsHtml)}

        <div class="bg-white p-6 rounded-xl border text-sm docs-output-form space-y-6">
          ${convertArray(linkItemsHtml)}
        </div>
      </div>
    </div>
    `
  )
}
